import PrimeReact, { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { ButtonGroup } from 'primereact/buttongroup';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Job, JobStatusEnum } from '../interface';

import { Toolbar } from 'primereact/toolbar';
import { useHistory } from 'react-router-dom';
import { AppDispatch } from '../../../../store';
import { deleteJobs, retrieveJobs, updateJob } from '../JobAction';
import { LOOKUPS_KEY } from '../../../../constants/localStorageKeys';
import { CategoryEnum } from '../../Lookup/enums';
import LinkButton from '../../../../constants/helpers/LinkButton';
import { Badge } from 'primereact/badge';
import { Menu } from 'primereact/menu';
import { useLookupOptions } from '../../../../constants/helpers/useLookupOptions';
import { navigationItem } from '../../../../constants/routes/admin/menus';
import { SCOPES } from '../../../../constants/scopes';

interface JobManagementProps {
}

const JobManagement = (props: JobManagementProps) => {
  PrimeReact.ripple = true
  const { } = props

  const toast = useRef<any>()
  const dt = useRef<any>(null);

  const dispatch = useDispatch<AppDispatch>()
  const { jobList, totalRecords } = useSelector((state: any) => state.job)
  const history = useHistory();

  // additional menus
  const menu = useRef<any>(null);
  const [selectedMenuJob, setSelectedMenuJob] = useState({} as Job);

  let filters: DataTableFilterMeta = {
    title: { value: null, matchMode: FilterMatchMode.EQUALS },
    employmentType: { value: null, matchMode: FilterMatchMode.EQUALS },
    contractType: { value: null, matchMode: FilterMatchMode.EQUALS },
    location: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    createdDate: { value: null, matchMode: FilterMatchMode.EQUALS },
  }
  const [rows, setRows] = useState(5)
  const [currentJob, setCurrentJob] = useState({} as Job)
  const [selectedJobs, setSelectedJobs] = useState([] as Job[])
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: "createdDate",
    sortOrder: -1,
    filters
  })

  // Dialog settings
  const [displayDeleteJobDialog, setDisplayDeleteJobDialog] = useState(false)
  const [displayDeleteMultiJobDialog, setDisplayDeleteMultiJobDialog] = useState(false)
  const dropdownItems = [
    ...navigationItem({
      scope: SCOPES.JOB_READ,
      label: 'Setup Interview Flow',
      icon: 'pi pi-cog',
      link: '/jobs/' + selectedMenuJob.id + '/setup',
    }, history),
    ...navigationItem({
      scope: SCOPES.JOB_READ,
      label: 'Match Resumes to this Job',
      icon: 'pi pi-sparkles',
      link: '/jobs/' + selectedMenuJob.id + '/match',
    }, history),
    ...navigationItem({
      scope: SCOPES.JOB_READ,
      label: 'View Interviews for this Job',
      icon: 'pi pi-video',
      link: '/jobs/' + selectedMenuJob.id + '/interviews',
    }, history),
  ]

  //Lazy loading
  useEffect(() => {
    init()
  }, [lazyParams])

  const init = () => {
    dispatch(retrieveJobs(lazyParams))
  }

  const onPage = (event: any) => {
    setRows(event.rows)
    let _lazyParams = { ...lazyParams, ...event }
    setLazyParams(_lazyParams)
    setSelectedJobs([])
  }

  const onSort = (event: any) => {
    let _lazyParams = { ...lazyParams, ...event }
    setLazyParams(_lazyParams)
    setSelectedJobs([])
  }

  const onFilter = (event: any) => {
    let _lazyParams = { ...lazyParams, ...event }
    _lazyParams['first'] = 0;
    setLazyParams(_lazyParams)
    setSelectedJobs([])
  }

  // Custom Filter Details
  const [selectedStatus, setSelectedStatus] = useState(null)
  const [selectedEmploymentType, setSelectedEmploymentType] = useState(null)
  const [selectedContractType, setSelectedContractType] = useState(null)
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [selectedDate, setSelectedDate] = useState(undefined)

  // Lookups
  const {
    countryList, employmentTypeList, contractTypeList,
  } = useLookupOptions()

  const statuses = Object.keys(JobStatusEnum).filter(k => isNaN(Number(k)));
  const statusModel = statuses.map(status => ({ label: status, value: status }))

  const onStatusChange = (e: any) => {
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters.status = { value: e.value, matchMode: FilterMatchMode.EQUALS }
    setLazyParams(_lazyParams)
    setSelectedStatus(e.value)
    setSelectedJobs([])
  }

  const onEmploymentTypeChange = (e: any) => {
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters.employmentType = { value: e.value, matchMode: FilterMatchMode.EQUALS }
    setLazyParams(_lazyParams)
    setSelectedEmploymentType(e.value)
    setSelectedJobs([])
  }

  const onContractTypeChange = (e: any) => {
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters.contractType = { value: e.value, matchMode: FilterMatchMode.EQUALS }
    setLazyParams(_lazyParams)
    setSelectedContractType(e.value)
    setSelectedJobs([])
  }

  const onLocationChange = (e: any) => {
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters.location = { value: e.value, matchMode: FilterMatchMode.EQUALS }
    setLazyParams(_lazyParams)
    setSelectedLocation(e.value)
    setSelectedJobs([])
  }

  const onDateChange = (e: any) => {
    setSelectedDate(e.value)
    if (e.value[0] != null && e.value[1] != null) {
      let startDate = `${e.value[0].getFullYear()}-${e.value[0].getMonth() + 1}-${e.value[0].getDate()}`
      let endDate = `${e.value[1].getFullYear()}-${e.value[1].getMonth() + 1}-${e.value[1].getDate() + 1}`
      let _lazyParams = { ...lazyParams }
      _lazyParams.filters.createdDateLt = { value: startDate, matchMode: FilterMatchMode.EQUALS }
      _lazyParams.filters.createdDateGt = { value: endDate, matchMode: FilterMatchMode.EQUALS }
      setLazyParams(_lazyParams)
      setSelectedJobs([])
    }
  }

  const dateFilter = <Calendar value={selectedDate} readOnlyInput selectionMode="range" onChange={onDateChange} dateFormat="yy-mm-dd" className="p-column-filter" placeholder="YYYY-MM-DD"></Calendar>
  const statusFilter = <Dropdown value={selectedStatus} options={statuses} onChange={onStatusChange} placeholder="All" className="p-column-filter" showClear></Dropdown>
  const employmentFilter = <Dropdown value={selectedEmploymentType} options={employmentTypeList} onChange={onEmploymentTypeChange} placeholder="All" className="p-column-filter" showClear></Dropdown>
  const contractFilter = <Dropdown value={selectedContractType} options={contractTypeList} onChange={onContractTypeChange} placeholder="All" className="p-column-filter" showClear></Dropdown>
  const locationFilter = <Dropdown value={selectedLocation} options={countryList} filter virtualScrollerOptions={{ itemSize: 38 }} onChange={onLocationChange} placeholder="All" className="p-column-filter" showClear></Dropdown>

  const handleResetFilters = () => {
    setSelectedStatus(null)
    setSelectedEmploymentType(null)
    setSelectedLocation(null)
    setSelectedContractType(null)
    setSelectedDate(undefined)
    dt.current.reset();
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters = {}
    setLazyParams(_lazyParams)
  }

  const getStatusStyling = (rowData: any) => {
    switch (rowData.status) {
      case JobStatusEnum.AVAILABLE:
        return <Badge value={rowData.status} severity="success"></Badge>
      case JobStatusEnum.REVIEWING:
        return <Badge value={rowData.status} severity="warning"></Badge>
      case JobStatusEnum.TAKEN:
        return <Badge value={rowData.status} severity="info"></Badge>
    }
  }

  const createdDateBodyTemplate = (rowData: any) => {
    let date = new Date(rowData.createdDate)
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  }

  const configJobTemplate = (rowData: any) => {
    return (
      <div>
        <ButtonGroup>
          <LinkButton to={"/jobs/" + rowData.id}
            icon="eye" iconOnly={true}
            tooltip="View Job" tooltipOptions={{ position: 'top' }} />
          <LinkButton to={"/jobs/" + rowData.id + "/update"}
            icon="pencil" iconOnly={true}
            tooltip="Modify Job" tooltipOptions={{ position: 'top' }} />
          <Button
            onClick={() => {
              handleSingleDeleteJobBtn(rowData)
              // setDisplayDeleteUserDialog(true)
            }}
            severity="secondary"
            tooltip="Delete Job"
            tooltipOptions={{ position: 'top' }}
            icon="pi pi-trash"
            aria-label="Delete" />
          <Button 
            icon="pi pi-angle-down" 
            severity="secondary"
            onClick={(event) => { menu.current.toggle(event); setSelectedMenuJob(rowData) }} />
        </ButtonGroup>

      </div>
    )
  }

  const handleSingleDeleteJobBtn = (rowData: Job) => {
    setCurrentJob(rowData)
    setDisplayDeleteJobDialog(true)
  }

  const confirmSingleDelete = () => {
    let jobsToDelete = []
    jobsToDelete.push(currentJob)
    dispatch(deleteJobs([currentJob])).unwrap()
      .then(() => {
        toast.current.show({
          severity: 'success',
          summary: 'Job Delete Success',
          detail: `Job (${currentJob.title}) successfully deleted.`,
          life: 3000
        })
        init()
      })
      .catch(() => {
        toast.current.show({
          severity: 'warn',
          summary: 'Job Delete Error',
          detail: `Job (${currentJob.title}) deletion failed.`,
          life: 3000
        })
      })
  }

  const handleMultiDeleteJobButton = (e: any) => {
    e.preventDefault()
    setDisplayDeleteMultiJobDialog(true)
  }

  const confirmMultiDelete = () => {
    dispatch(deleteJobs(selectedJobs)).unwrap()
      .then(() => {
        toast.current.show({
          severity: 'success',
          summary: 'Job Delete Success',
          detail: `${selectedJobs.length} jobs successfully deleted.`,
          life: 3000
        })
        init()
      })
      .catch(() => {
        toast.current.show({
          severity: 'warn',
          summary: 'Job Delete Error',
          detail: `${selectedJobs.length} jobs deletion failed`,
          life: 3000
        })
      })
    setSelectedJobs([])
  }

  const toolbar = () => {
    return (
      <>
        <Button type="button" label="Clear" className="p-button-outlined mr-2" icon="pi pi-filter-slash" onClick={handleResetFilters} />
        <LinkButton to={"/jobs/create"} icon="file" label="New" className="p-button-primary mr-2" />
        <Button label="Delete" icon="pi pi-trash" className="p-button-secondary" onClick={handleMultiDeleteJobButton} disabled={selectedJobs.length === 0}></Button>
      </>
    )
  }

  return (
    <div>
      <Toast ref={toast} />
      <Menu popup ref={menu} model={dropdownItems} id="menu" aria-controls="menu" aria-haspopup />
      <div className="datatable-doc-demo">
        <div className="card">
          <Toolbar className="p-mb-4" start={toolbar}></Toolbar>
          <ConfirmDialog visible={displayDeleteJobDialog} onHide={() => setDisplayDeleteJobDialog(false)} message={`Are you sure you want to delete the job: ${currentJob.title}?`} header="Confirmation" icon="pi pi-exclamation-triangle" acceptClassName='p-button-danger' accept={confirmSingleDelete} reject={() => setDisplayDeleteJobDialog(false)} />
          <ConfirmDialog visible={displayDeleteMultiJobDialog} onHide={() => setDisplayDeleteMultiJobDialog(false)} message={`Are you sure you want to delete ${selectedJobs.length} selected jobs?`} header="Confirmation" icon="pi pi-exclamation-triangle" acceptClassName='p-button-danger' accept={confirmMultiDelete} reject={() => setDisplayDeleteMultiJobDialog(false)} />
          <DataTable ref={dt} value={jobList} first={lazyParams.first} rows={rows} totalRecords={totalRecords}
            onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder as any}
            onFilter={onFilter} filters={lazyParams.filters} filterDisplay="row"
            selection={selectedJobs} onSelectionChange={e => {
              const jobs = e.value as Job[]
              setSelectedJobs(jobs)
            }}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" rowsPerPageOptions={[5, 10, 25]}
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            lazy paginator>
            <Column selectionMode="multiple" style={{ width: '3em', flexGrow: 0 }}></Column>
            <Column field="title" header="Title" filter sortable></Column>
            <Column field="employmentType" header="Employment" filter filterElement={employmentFilter} sortable></Column>
            {/* <Column field="contractType" header="Contract" filter filterElement={contractFilter} sortable></Column> */}
            <Column field="location" header="Location" filter filterElement={locationFilter} sortable></Column>
            <Column field="status" header="Status" body={getStatusStyling} filter filterElement={statusFilter} sortable></Column>
            <Column field="createdDate" header="Created Date" body={createdDateBodyTemplate} filter filterElement={dateFilter} sortable></Column>
            <Column body={configJobTemplate} style={{ width: '12em', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} />
          </DataTable>
        </div>
      </div>
    </div>
  )
}

export default JobManagement